import React, { useState, useEffect ,useContext} from "react";
import { useTranslation } from "next-i18next";
import style from "../../../styles/mystyle.module.css";
import { useMedia } from "../../../utils/use-media";
// import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/Button";
import Link from "next/link";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
// import DialogActions from "@mui/material/DialogActions";
import PropTypes from "prop-types";
// import * as config from "../../../next.config.js";
import CloseIcon from "@mui/icons-material/Close";
// import axios from "axios";
import { useRouter } from "next/router";
// import { constants } from "../../../constants";
// import getIncludeStatusIds from "../../helpers/global/getIncludeStatusIds";
// import getTermsByVocabCode from "../../helpers/global/term/term";
import getOffers from "../../helpers/offers";
import { locale } from "next/router";
import { useCart } from "../../../context/cart/use-cart";
import { printLogs, getCookieValue } from "../../helpers/helpers";
import { BootstrapDialog } from "../StyledComponent/Dialog.style"
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
// import AccordionDetails from '@mui/material/AccordionDetails'
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
// import Radio from '@mui/material/Radio'
import Checkbox from '@mui/material/Checkbox'
import FromControlLabel from '@mui/material/FormControlLabel'
// import FormControl from "@mui/material/FormControl"
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert'
import CurrencyContext from '../../../context/currencyProvider'
const CustomeAccordion = styled(Accordion)({
  '& .MuiSvgIcon-root ': {
    color: "#02AAB0"
  },
  '& .MuiAccordion-root': {
    boxShadow: "0 0 4px #bcbcbc",
  },

})
const CustomeAccordionSummary = styled(AccordionSummary)({
  '& .MuiAccordionSummary-content  ': {
    display: "grid",
    margin: 0
  },


})
const CustomeFormControl = styled(FromControlLabel)({
  '& .MuiFormControlLabel-label  ': {
    width: "100%"
  },


})
const Addcarddialog = props => {
  const { children, onClose, ...other } = props;
  return (
    <DialogTitle
      sx={{ m: 0, p: 2, display: "flex", justifyContent: "space-between" }}
      {...other}
      className={style.DialogTitle}
    >
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "90%",
            left: "85%",
            top: 6,
            marginBottom: 0,
            color: "#008C8D ",
            "@media (min-width:600px)": {
              left: "90%",
              top: 23,
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
Addcarddialog.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
};
function OtherUnitsPrice({ data, open, onClose }) {
  const { addItem, removeItem, isInCart, getItem, items, addFeatureItem, getFeatureItem, removeFeatureItem } = useCart();
  const router = useRouter();
  const { locale } = useRouter();
  const pid = router.query.pid;
 

  const [cartItems, setcartItems] = useState([]);
  const [count, setCount] = React.useState(0);
  const currency=useContext(CurrencyContext)
  const handlePlus = item => {
    let tempLst = [...cartItems];
    tempLst.filter(itm => itm.id == item)[0].count += 1;
    setcartItems([...tempLst]);
  };
 
  const handleMinus = (e, data) => {
    // let tmp2 = count - 1;
    // setCount(tmp2);

    handleRemoveButton(data);
  };

  const { t } = useTranslation("common");

  let getExchangeCurrency = null
  const [productOffer, setProductOffer] = useState(null)
  useEffect(() => {
  
  


    setProductOffer(data)
  }, [open]);
  
  const handleRemoveButton = data => {
    removeItem(data);
  };
  let quantity = []
  const [state, setState] = React.useState({
    open: false,
    vertical: 'top',
    horizontal: 'center',
    message: ""
  });
  const { vertical, horizontal } = state;
  return (
    <BootstrapDialog
      onClose={() => onClose(false)}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: "50%",
            left: "50%",
            top: 10,
            marginBottom: 0,
            color: "#008C8D ",
            "@media (min-width:600px)": {
              left: "85%"
            }
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
      <DialogContent dividers>

        <div className={style.ImgDiolagAddcard}>
          <Snackbar
            autoHideDuration={2000}
            anchorOrigin={{ vertical, horizontal }}
            open={state.open}
            onClose={() => setState({ ...state, open: false })}
            message={state.message}
            key={vertical + horizontal}
            sx={{
              backgroundColor: "#f52a59", '& .MuiPaper-root': {
                backgroundColor: "#f52a59"
              }
            }}
          >
            <Alert severity="info" sx={{
              color: "#ffffff", "& .MuiAlert-icon": {
                color: "#fff"
              }
            }} >{state.message}</Alert>
          </Snackbar>
  
          {productOffer !=null ? (
     
     <div className={style.card1}>
             {(() => {
                  let offerCurrencyId = productOffer.currencyId 
                  getExchangeCurrency = currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == offerCurrencyId && ele.to == currency.currency)

                  if (getExchangeCurrency && getExchangeCurrency.length > 0) {
                    getExchangeCurrency = getExchangeCurrency[0].exchangedAmount
                  }
                  else {

                    getExchangeCurrency = currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.length > 0 && currency.exchangeCurrencyRes.filter(ele => ele.from ==offerCurrencyId).length > 0 ? currency.exchangeCurrencyRes && currency.exchangeCurrencyRes.filter(ele => ele.from == offerCurrencyId)[0].exchangedAmount : 1
                  }

                  quantity.push({
                    index: 0, value: getItem(
                      productOffer.productId,
                      productOffer.productUnitPriceId,
                      productOffer.entityDetailsId,
                      getCookieValue("userCountry")
                    ) != null
                      ? getItem(
                        productOffer.productId,
                        productOffer.productUnitPriceId,
                        productOffer.entityDetailsId,
                        getCookieValue("userCountry")
                      ).quantity : 0
                  })
                  return (
                    <React.Fragment >

                      <>
                        <div >
                          <div
                            className={
                              style.nameAndQuantityBox
                            }
                            style={{ padding: 0 }}
                          >

                            <div
                              className={
                                style.textaboutdoctor2 + " " + style.textaligncenter
                              }
                              style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                         
                              {productOffer.product && productOffer.product.length > 0? productOffer.product[0].productName: ""}
                              <span style={{ marginRight: 2 }}>
                                {
                                  productOffer.unit
                                    && productOffer.unit
                                      .length && productOffer.unit.filter(i => i.language.code == router.locale).length > 0 ?
                                    <span>({productOffer.unit && productOffer.unit.filter(i => i.language.code == router.locale)[0].name})</span>
                                    : <span>({productOffer.unit[0].name})</span>

                                }
                              </span>


                            </div>

                            <div className={style.BottomQuantity}>
                              {isInCart(
                                productOffer.productId,
                                "products",
                                productOffer.productUnitPriceId,
                                productOffer.entityDetailsId,
                                getCookieValue("userCountry")
                              ) ? (
                                <div className={style["DivCount-product"]
                                  + " " + style.Addcomfirmation
                                  + " " +
                                  style.BasketAddWidthDialog}

                                  style={{ margin: 0 }}
                                >
                       
                                  <button
                                    className={style["count-product-features"]}
                                    onClick={e =>
                                     { 
                                 
                                      addItem({
                                        type: "products",
                                        entityId:productOffer.productId,
                                        isFavoriate: false,
                                        quantity: 1,
                                        productUnitPrice:  productOffer.productUnitPriceId,
                                        entityDetailsId:  productOffer.entityDetailsId,
                                        userCountry: getCookieValue("userCountry")
                                      })}
                                    }
                                  >
                                    <AddIcon />
                                  
                                  </button>

                                  <div>
                                    <p style={{ marginBottom: 0 }}>
                                      {getItem(
                                        productOffer.productId,
                                        productOffer.productUnitPriceId,
                                        productOffer.entityDetailsId,
                                        getCookieValue("userCountry")
                                      ) != null
                                        ? getItem(
                                          productOffer.productId,
                                          productOffer.productUnitPriceId,
                                          productOffer.entityDetailsId,
                                          getCookieValue("userCountry")
                                        ).quantity
                                        : ""}
                                    </p>
                                  </div>

                                  <button
                                        className={style["count-product-features"]}
                                    onClick={e =>{
                                    
                                      let getTempItem=getItem(
                                        productOffer.productId,
                                        productOffer.productUnitPriceId,
                                        productOffer.entityDetailsId,
                                        getCookieValue("userCountry")
                                      )
                                      if(getTempItem.productUnitPriceFeatures&&getTempItem.productUnitPriceFeatures.length>0){
                                        let isQuantityFalseLst=getTempItem.productUnitPriceFeatures.filter(d=>d.isQuantity==false).sort((a,b)=>a.index-b.index)
                                        
                                        if(getTempItem.quantity>=isQuantityFalseLst.length){
                  
                                              removeFeatureItem({productUnitPriceFeatures:{...isQuantityFalseLst[[...Array(getTempItem.quantity).keys()][0]], quantity: 1}})
                                        }
                                 
                                      }
                                     
                                      removeItem({
                                        type: "products",
                                        entityId:  productOffer.productId,
                                        isFavoriate: false,
                                        quantity: 1,
                                        productUnitPrice:  productOffer.productUnitPriceId,
                                        entityDetailsId:  productOffer.entityDetailsId,
                                        userCountry: getCookieValue("userCountry")
                                      })
                                    
                                    }
                                    }
                                  >
                                    <RemoveIcon />
                                  </button>
                                 
                                </div>
                              ) : (
                                <button
                                  className={style.Addcomfirmation +
                                    " " +" "+style.btnAddInOtherPrices}
                                  onClick={() => 
                                    addItem({
                                      type: "products",
                                      entityId:productOffer.productId,
                                      isFavoriate: false,
                                      quantity: 1,
                                      productUnitPrice:  productOffer.productUnitPriceId,
                                      entityDetailsId:  productOffer.entityDetailsId,
                                      userCountry: getCookieValue("userCountry")
                                    })
                                   
                                  
                                  }
                                >
                                  <p style={{ marginBottom: 0 }}>
                                    {t("add")}
                                  </p>
                                </button>
                              )}
                              <div>

                                {" "}

                              </div>
                            </div>

                          </div>
                        </div>
                        <div className={style.card1}>
                          <div className={style.borderbottomdialog}></div>
                        </div>

                        <div  style={{ maxHeight: "400px", overflowY: "scroll", height: "100%", paddingTop: 10, paddingBottom: 10, overflowX: "hidden" }}>
                          {productOffer.ProductUnitPriceFeatures && productOffer.ProductUnitPriceFeatures.length > 0 ?productOffer.ProductUnitPriceFeatures.sort((a, b) => Number(a.quantity) - Number(b.quantity)).map(i => {


                            return <>
                              {(() => {

                                return <>
                                  <p style={{ fontSize: "18px", margin: "0px" }}>
                                    {i.ProductFeatures && i.ProductFeatures.length && i.ProductFeatures[0].transProductFeatures.length > 0 ? i.ProductFeatures && i.ProductFeatures.length && i.ProductFeatures[0].transProductFeatures.filter(x => x.language.code == router.locale).length > 0 ? i.ProductFeatures && i.ProductFeatures.length && i.ProductFeatures[0].transProductFeatures.filter(x => x.language.code == router.locale)[0].name : i.ProductFeatures && i.ProductFeatures.length && i.ProductFeatures[0].transProductFeatures[0].name : ""}
                                  </p>

                                </>
                                // }
                              })()}
                              {(() => {


                                return i.ProductUnitPriceFeaturesDetails.map((a ,index)=> {

                                  let procurrency =currency.currenciesLst.filter(ele => ele.id == currency.currency).length && currency.currenciesLst.filter(ele => ele.id == currency.currency)[0].transCurrency.filter(ele => ele.language.code == router.locale)[0].currencySymbol
                                  return <>
                                    <div className="flex pl-10 pr-10">
                                      <CustomeFormControl
                                        sx={{
                                          "& .MuiFormControlLabel-root .MuiTypography-root": {
                                            width: "100%"
                                          }, "& .MuiFormControlLabel-root": { width: "100%" }, width: "100%"
                                        }}
                                        control={

                                          <Checkbox
                                            style={{ color: "#f52a59" }}
                                            checked={getFeatureItem(
                                              productOffer.productId,
                                              productOffer.productUnitPriceId,
                                              productOffer.entityDetailsId,
                                              getCookieValue("userCountry"),
                                              a.id,
                                              a.productUnitPriceId

                                            ) != null ? true : false}
                                            onChange={(e) => {
                                            


                                              if (e.target && e.target.checked == true) {
                                                     if(! isInCart(productOffer.productId, "products", productOffer.productUnitPriceId,  productOffer.entityDetailsId,   getCookieValue("userCountry"))){
                                                      addItem({
                                                        type: "products",
                                                        entityId:productOffer.productId,
                                                        isFavoriate: false,
                                                        quantity: 1,
                                                        productUnitPrice:  productOffer.productUnitPriceId,
                                                        entityDetailsId:  productOffer.entityDetailsId,
                                                        userCountry: getCookieValue("userCountry")
                                                      })
                                                    }
                                                    
                                                if (i.quantity == false) {
                                                  let totalQuantity = 0
                                                  let productUnitPriceFeatures = getItem(productOffer.productId, productOffer.productUnitPriceId, productOffer.entityDetailsId, getCookieValue("userCountry")) && getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).productUnitPriceFeatures && getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).productUnitPriceFeatures.length ? getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).productUnitPriceFeatures.filter(x => x.productFeatureId == i.productFeatureId) : []
                                                  productUnitPriceFeatures.length ? productUnitPriceFeatures.map(a => {
                                                    totalQuantity += a.quantity
                                                  }) : ""

                                                  if(totalQuantity >0 && getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry"))){

                                                

                                                  if (totalQuantity <getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).quantity) {

                                                    addFeatureItem({
                                                      productUnitPriceFeatures: {
                                                        quantity: 1,
                                                        productUnitPriceId:productOffer.productUnitPriceId,
                                                        productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                        productFeatureId: i.productFeatureId,
                                                        isQuantity:i.quantity ,
                                                        index:index
                                                      }

                                                    })
                                                  }
                                                  else {
                                                    state.open = true
                                                    state.message = t("maxQuantityMsg")
                                                    setState({ ...state })
                                                  }
                                                }else{
                                                  addFeatureItem({
                                                    productUnitPriceFeatures: {
                                                      quantity: 1,
                                                      productUnitPriceId:productOffer.productUnitPriceId,
                                                      productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                      productFeatureId: i.productFeatureId,
                                                      isQuantity:i.quantity ,
                                                      index:index
                                                    }

                                                  })
                                                }

                                                }
                                                else {
                                                  addFeatureItem({
                                                    productUnitPriceFeatures: {
                                                      quantity: 1,
                                                      productUnitPriceId:productOffer.productUnitPriceId,
                                                      productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                      productFeatureId: i.productFeatureId,
                                                      maxQuantity:i.maxQuantity,
                                                      isQuantity:i.quantity ,
                                                      index:index
                                                    }

                                                  })
                                                }

                                              } else {
                                                removeFeatureItem({
                                                  productUnitPriceFeatures: {
                                                    quantity: 0,
                                                    productUnitPriceId: productOffer.productUnitPriceId,
                                                    productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                    productFeatureId: i.productFeatureId,
                                                    maxQuantity:i.maxQuantity
                                                  }
                                                })
                                              }
                                            }}
                                          />
                                        }
                                        label={
                                          <div style={{ width: "100%", paddingBottom: 10 }}>
                                            <div
                                            
                                              style={{ display: "flex", width: "100%" }}
                                            >

                                              <div style={{ margin: "0px", display: "flex", alignItems: "center", "width": "50%" }}>
                                                {a.product && a.product.length && a.product[0].transProduct.length ? a.product[0].transProduct && a.product[0].transProduct.filter(i => i.language.code == router.locale).length > 0 ? a.product[0].transProduct && a.product[0].transProduct.filter(i => i.language.code == router.locale)[0].name : a.product[0].transProduct && a.product[0].transProduct[0].name : ""}
                                              </div>
                                              <div style={{ "width": "50%", display: "flex", alignItems: "center" }}>
                                                {(() => {
                                                  let hasOffer = false
                                                  let offerPrice = null
                                         

                                                  let offerData = a.productOffer && a.productOffer
                                                  if (a.product.length && a.product[0].productUnitPrice[0].price > 0) {
                                                    if (a.product.length && a.product[0].productUnitPrice[0].displayPrice == true) {
                                                      if (offerData && offerData.length > 0) {
                                                        hasOffer = true
                                                        offerPrice = getOffers(
                                                          offerData[0].fixedPrecentage,
                                                         a.product[0].productUnitPrice[0].price,
                                                          offerData[0].fixedAmount
                                                        )

                                                      }
                                                      return <>

                                                        {offerPrice == a.product[0].productUnitPrice[0] ? "" :
                                                          <div
                                                            className={
                                                              // style.textaboutdoctor2 +
                                                              style.priceTextInProduct +
                                                              " " +
                                                              style.marginbottom
                                                            }
                                                            style={{margin:"0px 8px", textDecoration: hasOffer ? "line-through" : "none", textDecorationColor: hasOffer ? "red" : "none" }}>
                                                            {(a.product.length && a.product[0].productUnitPrice[0].price * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 }) + " " + procurrency}

                                                          </div>
                                                        }
                                                        
                                                        {hasOffer ? <div
                                                          className={
                                                            // style.textaboutdoctor2 +
                                                            style.priceTextInProduct +
                                                            " " +
                                                            style.marginbottom}
                                                          style={{ marginRight: 2 }}>
                                                          {(offerPrice * getExchangeCurrency).toLocaleString('en-US', { minimumFractionDigits: 2 })}

                                                          {" "}
                                                          {procurrency}
                                                        </div> : ""}

                                                      </>
                                                    }
                                                    else {

                                                      return t("priceHiddin")
                                                    }
                                                  }
                                                })()}

                                              </div>




                                            </div>
                                          </div>
                                        }
                                      />

<div style={{ display: "flex", width: "33%", justifyContent: "end" }}>
                                                {getFeatureItem(
                                                 productOffer.productId, 
                                                 productOffer.productUnitPriceId,
                                                   productOffer.entityDetailsId,
                                                  getCookieValue("userCountry"),
                                                  a.id,
                                                  a.productUnitPriceId

                                                ) ? (
                                                  (i.quantity == true && a.maxQuantity == 0) ? ""
                                                    :
                                                    <div className={style["DivCount-product-features"]
                                                      + " " + style.Addcomfirmation
                                                    }
                                                      style={{ width: "80% !important", margin: 0 }}
                                                    >
                                                      <button
                                                        className={style.Count}
                                                        style={{ margin: "0px",color:"white" }}
                                                        onClick={e => {
                                                          if (i.quantity == true) {
                                                            if(a.maxQuantity >0 ){
                                                            if (a.maxQuantity > getFeatureItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry"), a.id, a.productUnitPriceId).quantity) {

                                                              addFeatureItem({
                                                                productUnitPriceFeatures: {
                                                                  quantity: 1,
                                                                  productUnitPriceId: productOffer.productUnitPriceId,
                                                                  productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                                  productFeatureId: i.productFeatureId,
                                                              
                                                                  isQuantity:i.quantity,
                                                                  index:index 
                                                                }

                                                              })
                                                            }else{
                                                             
                                                                state.open = true
                                                                state.message = t("maxQuantityMsg")
                                                                setState({ ...state })
                                                              
                                                            }
                                                          }else{
                                                              addFeatureItem({
                                                                productUnitPriceFeatures: {
                                                                  quantity: 1,
                                                                  productUnitPriceId: productOffer.productUnitPriceId,
                                                                  productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                                  productFeatureId: i.productFeatureId,
                                                              
                                                                  isQuantity:i.quantity,
                                                                  index:index 
                                                                }

                                                              })
                                                            }
                                                          } else {
                                                            let totalQuantity = 0
                                                            let productUnitPriceFeatures = getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")) && getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).productUnitPriceFeatures.length ? getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).productUnitPriceFeatures.filter(x => x.productFeatureId == i.productFeatureId) : []
                                                            productUnitPriceFeatures.length ? productUnitPriceFeatures.map(a => {

                                                              totalQuantity += a.quantity
                                                            }) : ""

                                                            if (totalQuantity < getItem(productOffer.productId, productOffer.productUnitPriceId,  productOffer.entityDetailsId, getCookieValue("userCountry")).quantity) {

                                                              addFeatureItem({
                                                                productUnitPriceFeatures: {
                                                                  quantity: 1,
                                                                  productUnitPriceId: productOffer.productUnitPriceId,
                                                                  productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                                  productFeatureId: i.productFeatureId,
                                                                  isQuantity:i.quantity ,
                                                                  index:index
                                                                }
                                                              })
                                                            }else{
                                                              
                                                                state.open = true
                                                                state.message = t("maxQuantityMsg")
                                                                setState({ ...state })
                                                              
                                                            }
                                                          }
                                                        }}
                                                      >
                                                        <AddIcon />
                                                      </button>

                                                      <div>
                                                        <p style={{ marginBottom: 0 }}>
                                                          {getFeatureItem(
                                                productOffer.productId,
                                                 productOffer.productUnitPriceId,  
                                                 productOffer.entityDetailsId,
                                                            getCookieValue("userCountry"),
                                                            a.id,
                                                            a.productUnitPriceId

                                                          ) != null
                                                            ? getFeatureItem(
                                                              productOffer.productId,
                                                              productOffer.productUnitPriceId,  
                                                              productOffer.entityDetailsId,
                                                              getCookieValue("userCountry"),
                                                              a.id,
                                                              a.productUnitPriceId

                                                            ).quantity
                                                            : ""}
                                                        </p>
                                                      </div>

                                                      <button
                                                        className={style.Count}
                                                        style={{ margin: "0px",color:"white" }}
                                                        onClick={e =>
                                                          removeFeatureItem({
                                                            productUnitPriceFeatures: {
                                                              quantity: 1,
                                                              productUnitPriceId: productOffer.productUnitPriceId,
                                                              productUnitPriceFeaturesDetails: { id: a.id, ProductUnitPriceId: a.productUnitPriceId },
                                                              productFeatureId: i.productFeatureId,
                                                              isQuantity:i.quantity 
                                                            }
                                                          })
                                                        }
                                                      >
                                                        <RemoveIcon />

                                                      </button>

                                                    </div>
                                                ) : (""

                                                )}
                                              </div>
                                    </div>
                                  </>
                                })

                              })()}
                              <div className={style.card1}>
                                <div className={style.borderbottomdialog}></div>
                              </div>
                            </>
                          }) : ""}
                        </div>




                        <div className={style.borderbottomdialog}></div>
                      </>

                    </React.Fragment>
                  );
                })()}
            </div>


          ) : (
            ""
          )}

          {productOffer &&productOffer !=null ? <div className={style.FlexPM + " " + style.paddingLinkMobile}>
            <Link
              href={{
                pathname: `/basket`,
                locale: locale
              }}
              className={style.AtagIcon + " " + style.wid_Btn_dia}
            >


              <button
                className={quantity && quantity.filter(i => i.value > 0).length > 0 ? style.Addcomfirmation : style.disAddcomfirmation + " " + style.widthbtncontact}
                disabled={
                  quantity && quantity.filter(i => i.value > 0).length > 0 ? false : true
                }
              >
                {t("btnGoToCart")}
              </button>

            </Link>
          </div> : ""}
        </div>

        <br />
      </DialogContent>


    </BootstrapDialog>
  );
}

export default OtherUnitsPrice;
